module.exports = __webpack_public_path__ + "static/media/icon-catalog-info.d598133a.svg";